module.exports = __webpack_public_path__ + "img/nogodroptest-min.a0431b57.jpg";